export const POSITIVE_LIST_QUERY_KEY = "gdpr-software-positive-list";

export const USAGE_STATUS_OPTIONS = [
    { value: "yes", labelKey: "Yes" },
    { value: "no", labelKey: "No" },
    { value: "to_review", labelKey: "Provided by Provider" },
];

export const MEASURE_TYPE_OPTIONS = [
    { value: "technical", labelKey: "Technical" },
    { value: "organizational", labelKey: "Organizational" },
    { value: "operational", labelKey: "Operational" },
];

const USAGE_STATUS_LABELS = {
    yes: "Yes",
    no: "No",
    to_review: "Provided by Provider",
};

const MEASURE_TYPE_LABELS = {
    technical: "Technical",
    organizational: "Organizational",
    operational: "Operational",
};

const MEASURE_TYPE_BADGE_LABELS = {
    technical: "Technical measure",
    organizational: "Organizational measure",
    operational: "Operational measure",
};

export const getUsageStatusLabel = (status) => {
    return USAGE_STATUS_LABELS[status] || status || "";
};

export const getMeasureTypeLabel = (measureType) => {
    return MEASURE_TYPE_LABELS[measureType] || measureType || "";
};

export const getMeasureTypeBadgeLabel = (measureType) => {
    return MEASURE_TYPE_BADGE_LABELS[measureType] || getMeasureTypeLabel(measureType);
};

export const buildPositiveListQueryParams = ({
    usageStatus,
    measureType,
    search,
} = {}) => {
    const params = {};

    if (usageStatus) {
        params.usage_status = usageStatus;
    }

    if (measureType) {
        params.measure_type = measureType;
    }

    const query = typeof search === "string" ? search.trim() : "";

    if (query) {
        params.q = query;
    }

    return params;
};

export const hasPositiveListFilters = (filters = {}) => {
    return Boolean(
        filters.usageStatus
        || filters.measureType
        || (typeof filters.search === "string" && filters.search.trim())
    );
};

const toCount = (value) => {
    const count = Number(value);

    return Number.isFinite(count) ? count : 0;
};

export const normalizePositiveList = (payload) => {
    const summary = payload?.summary || {};
    const items = Array.isArray(payload?.items) ? payload.items : [];

    return {
        summary: {
            used: toCount(summary.used),
            notUsed: toCount(summary.not_used),
            toReview: toCount(summary.to_review),
            pendingUserConfirmation: toCount(summary.pending_user_confirmation_count),
        },
        items,
    };
};

export const getVisibleControls = (controls, limit = 2) => {
    const items = Array.isArray(controls) ? controls : [];

    return {
        visible: items.slice(0, limit),
        remaining: Math.max(0, items.length - limit),
    };
};

export const formatControlChip = (control) => {
    const number = control?.control_number || control?.controlNumber || "";
    const title = control?.title || "";

    return [number, title].filter(Boolean).join(" ");
};
